import React, { useState } from 'react';
import { TLabel, t } from 'util/stdtypes';
import { VertBox } from 'component/basics';
import { BlocklistTextInputWithChips } from 'open-modules/zdf/component/blocklist/blocklistTextInput';
import { component, demoFile, story, INPUT, CLICK } from 'system/demo';

demoFile('open-modules/zdf/component/blocklist-input');

function BlocklistTextInputWithChipsDemo() {
    const [inputText, setInputText] = useState('');
    const [terms, setTerms] = useState<string[]>([]);
    const [errorMessage, setErrorMessage] = useState<TLabel | "">("");

    return (
        <VertBox gap={8}>
            <BlocklistTextInputWithChips
                inputText={inputText}
                setInputText={setInputText}
                terms={terms}
                setTerms={setTerms}
                testID="input"
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
            />
        </VertBox>
    );
}

component('BlocklistTextInputWithChips', BlocklistTextInputWithChipsDemo, {
    state: {
        serverCall: {
            blocklist: {
                findTermInBlocklist: async () => false,
            },
        },
    },
}, [
    story('Add terms', [INPUT('input', 'term1; term2'), CLICK('term1')])
]);
